export default {
  methods: {
    /**
     * @description 外部暴露的更新单元格数据方法
     */
    updateCell(rowIndex, key, value) {
      this.$set(this.apexTableData, rowIndex, {
        ...this.apexTableData[rowIndex],
        [key]: value
      })
    },
    /**
     * @description 外部暴露的编辑行方法
     */
    updateRow(index, row) {
      this.handleUpdateRow(index, row)
    },
    /**
     * @description 外部暴露的删除行方法
     */
    removeRow(index) {
      this.handleRemoveRow(index)
    },
    /**
     * @description 用于可展开表格与树形表格，切换某一行的展开状态，如果使用了第二个参数，则是设置这一行展开与否（expanded 为 true 则展开）
     */
    toggleRowExpansion(row, expanded) {
      this.$nextTick(() => {
        this.$refs.elTable.toggleRowExpansion(row, expanded)
      })
    },
    // 取消单选选中行
    setCurrentRow(index) {
      this.$nextTick(() => {
        if (index === undefined) {
          this.$refs.elTable.setCurrentRow()
          this.tempRadioId = false
        } else {
          const row = this.apexTableData[index]
          this.$refs.elTable.setCurrentRow(row)
          this.tempRadioId = index
        }
      })
    },
    // 切换多选选中
    toggleRowSelection(index, selected) {
      this.$nextTick(() => {
        if (index === undefined) {
          this.$refs.elTable.clearSelection()
        } else {
          const row = this.apexTableData[index]
          this.$refs.elTable.toggleRowSelection(row, selected)
        }
      })
    },
    // 刷新table布局
    doLayout() {
      this.$nextTick(() => {
        this.$refs.elTable.doLayout()
      })
    },
    /**
     *  获取 el-table 实例
     * @returns {*}
     */
    getElTable() {
      return this.$refs.elTable
    },
    /**
     * 获取当前列表数据
     * @returns
     */
    getApexTableData() {
      return this.apexTableData
    },
    // 清空表格颜色状态
    clearAllMarkRow() {
      this.$nextTick(() => {
        this.$refs.apexToolbar.$refs.apexColorPicker.clearThisStorage()
      })
    },
    // 手动重置某一行mark状态
    setMarkRow(row, color) {
      this.$nextTick(() => {
        this.$refs.apexToolbar.$refs.apexColorPicker.saveOptionsToStorage(row, color)
      })
    },
    // 重置懒加载展开行状态（展开状态和加载状态）
    resetAllExpandRowStatus() {
      this.$nextTick(() => {
        this.$refs.elTable.store.states.lazyTreeNodeMap = {}
        const treeData = this.$refs.elTable.store.states.treeData
        for (const key in treeData) {
          if (treeData[key].loaded) {
            treeData[key].expanded = false
            treeData[key].loaded = false
          }
        }
      })
    },
    // load懒加载多选模式下父子节点相关联
    lazyLoadNodeAssociat(row, res) {
      this.$nextTick(() => {
        const selectList = this.$refs.elTable.store.states.selection
        if (selectList.includes(row)) {
          res.forEach(item => {
            selectList.push(item)
          })
          this.handleSelectionChange(selectList)
        }
      })
    },
    // 清空filterColumnObj数据
    clearFilterColumnValue() {
      // for (const key in this.filterColumnObj) {
      //   this.$set(this.filterColumnObj, key, '')
      // }
      this.initFilterColumnObj()
    },
    // 获取组合排序最新sortList
    getComSortList() {
      return this.$refs.apexToolbar.$refs.apexCombSort.currentValue
    },
    // 设置组合排序的列
    setCombSortList(list) {
      this.$refs.apexToolbar.setCombSortList(list)
    }
  }
}
